module.exports = __webpack_public_path__ + "img/w矩形 82@3x.5426d4ac.png";